// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__H4PCG","error":"Textarea_error__3UMiZ","readonly":"Textarea_readonly__1doQE","disabled":"Textarea_disabled__2y5gz"};